// import { UserLayout } from '@/components/layouts'

export const constantRouterMap = [
  // {
  //   path: '/user',
  //   component: UserLayout,
  //   redirect: '/user/login',
  //   hidden: true,
  //   children: [
      
  //     {
  //       path: 'login',
  //       name: 'login',
  //       component: () => import(/* webpackChunkName: "user" */ '@/views/user/Login')
  //     },
  //     // {
  //     //   path: 'register',
  //     //   name: 'register',
  //     //   component: () => import(/* webpackChunkName: "user" */ '@/views/user/Register')
  //     // },
  //   ]
  // },
  {
    // nft管理
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index')
  },
  {
    path: '/',
    component: () => import('@/views/layout/layout'),
    redirect: '/layout/NewManage',
    children: [
      {
        // nft管理
        path: '/layout/NFTManage',
        name: 'NFTManage',
        component: () => import('@/views/nftManage/index')
      },
      {
        // 标签管理
        path: '/layout/TagManage',
        name: 'TagManage',
        component: () => import('@/views/tagManage/index')
      },
      {
        // 组别管理
        path: '/layout/GroupManage',
        name: 'GroupManage',
        component: () => import('@/views/groupManage/index')
      },
      {
        // 新闻管理
        path: '/layout/NewManage',
        name: 'NewManage',
        component: () => import('@/views/newManage/index')
      },
      {
        // 激活码管理
        path: '/layout/RedeemCodeManage',
        name: 'RedeemCodeManage',
        component: () => import('@/views/redeemCodeManage/index')
      },
      {
        // 激活码详情
        path: '/layout/RedeemCodeManage/detail',
        name: 'RedeemCodeDetail',
        component: () => import('@/views/redeemCodeManage/detail')
      },
    ]
  }
]